// Solunary i18n — point d'entrée unique de la langue produit.
//
// Anglais = langue par défaut ET langue de référence : toute clé absente dans la
// langue sélectionnée DÉGRADE vers l'anglais (jamais vers le français — c'était
// l'ancien invariant, inversé lors du passage EN-défaut).
//
// Structure : dictionaries/<namespace>/{base.js + fragments}.js, fusionnés par
// mergeFragments (clé dupliquée = throw en dev). Pas de chargement async/lazy :
// tout est dans le bundle pour zéro latence.
//
// Consommation : via le shim historique "@/lib/i18n" et useT("namespace")
// (LanguageContext) — n'importez pas "@/i18n" directement, l'alias "@/" n'est
// pas mappé côté Jest (voir lib/LanguageContext.jsx).
import common from "./dictionaries/common";
import saas from "./dictionaries/saas";
import admin from "./dictionaries/admin";
import clients from "./dictionaries/clients";
import marketplace from "./dictionaries/marketplace";
import superadmin from "./dictionaries/superadmin";
import crud from "./dictionaries/crud";
import publicPages from "./dictionaries/public";
import templates from "./dictionaries/templates";
// crm-module BEGIN C1.01
import crm from "./dictionaries/crm";
// crm-module END

export const DICTIONARIES = {
  common,
  saas,
  admin,
  clients,
  marketplace,
  superadmin,
  crud,
  public: publicPages,
  templates,
  // crm-module BEGIN C1.01
  crm,
  // crm-module END
};

/** Langue de référence (complète par construction) et ordre du sélecteur. */
export const BASE_LANG = "en";
export const SUPPORTED_LANGS = ["en", "fr", "es"];

/** Récupère une traduction : langue demandée → anglais → fallback explicite → clé. */
export function lookup(namespace, key, lang, fallback) {
  const ns = DICTIONARIES[namespace] || {};
  const dict = ns[lang] || ns[BASE_LANG] || {};
  if (key in dict) return dict[key];
  const base = ns[BASE_LANG] || {};
  if (key in base) return base[key];
  return fallback != null ? fallback : key;
}

/** Interpolation type {name}. */
export function interpolate(str, vars) {
  if (!vars || !str) return str;
  return Object.keys(vars).reduce((acc, k) => acc.replace(new RegExp(`\\{${k}\\}`, "g"), vars[k]), str);
}

export { pickLocalized } from "./pickLocalized";
export { mergeFragments, LANGS } from "./mergeFragments";
